import * as React from 'react'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableSortLabel from '@mui/material/TableSortLabel'
import TableRow from '@mui/material/TableRow'
import DeleteIcon from '@mui/icons-material/Delete'
import VisibilityIcon from '@mui/icons-material/Visibility'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import DescriptionIcon from '@mui/icons-material/Description'
import EditNoteIcon from '@mui/icons-material/EditNote'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import Checkbox from '@mui/material/Checkbox'

import { Box, FormControl, IconButton, Menu, MenuItem, Select, TablePagination, Tooltip } from '@mui/material'
import { Cell, TableMain, Title } from './styled'
import ModalConfirm from '~components/modais/modalConfirm'
import moment from 'moment'

import { colors } from '~constants/colorsPallete'
import ModalRefusalReason from '~components/modais/modalRefusalReason'
import { CustomTable } from '../conversationsTable/styled'
import { override } from 'pages/PushNotificationPage'
import { MoonLoader } from 'react-spinners'
import { DocumentsTableProps } from './types'
import { cnpjMask } from '~utils/cnpjMask'
import { useUserStore } from 'stores/users'
import { UpdateOperatorStatus } from '~services/Receipts'
import { toast } from 'react-toastify'
import { formatCurrency } from '~components/mobileCards/MaisRealizados'

// TODO: OMG I need a refactor so much it's unreal
export default function NotasTable({
  data,
  count,
  loading,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  onSelectionChange,
  onSortChange,
  currentOrderBy,
  currentOrderDirection,
}: DocumentsTableProps) {
  const [open, setOpen] = React.useState(false)
  const [openReason, setOpenReason] = React.useState(false)
  const [reasonText, setReasonText] = React.useState<string>('')
  const [idnfs, setIdnfs] = React.useState('')
  const [menuAnchorEl, setMenuAnchorEl] = React.useState<null | HTMLElement>(null)
  const [menuRow, setMenuRow] = React.useState<any | null>(null)
  const Uid = useUserStore((state) => state.phone)
  const access = useUserStore((state) => state.token)
  const client = useUserStore((state) => state.client)
  const [operatorStatuses, setOperatorStatuses] = React.useState<Record<string, string>>({})
  const [canEditByHashid, setCanEditByHashid] = React.useState<Record<string, boolean>>({})

  const [selectedIds, setSelectedIds] = React.useState<Set<string>>(new Set())
  // Sorting state
  const [orderBy, setOrderBy] = React.useState<string>('competence_date')
  const [orderDirection, setOrderDirection] = React.useState<'asc' | 'desc'>('desc')

  // Keep local sorting state in sync with external filters (e.g., when "Limpar filtros" resets sorting)
  React.useEffect(() => {
    // Only update if external values are provided and different from current local state
    if (currentOrderBy && currentOrderBy !== orderBy) {
      setOrderBy(currentOrderBy)
    }
    if (currentOrderDirection && currentOrderDirection !== orderDirection) {
      setOrderDirection(currentOrderDirection)
    }
  }, [currentOrderBy, currentOrderDirection, orderBy, orderDirection])

  const operatorStatusLabels: Record<string, string> = {
    refused_by_operator: 'Recusado pelo operador',
    approved: 'Aprovado',
    received_externally: 'Recebida fora da plataforma',
  }
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, row) => {
    setMenuAnchorEl(event.currentTarget)
    setMenuRow(row)
  }
  const handleMenuClose = () => {
    setMenuAnchorEl(null)
    setMenuRow(null)
  }

  // Map table headers to backend sortable fields
  const sortableColumns: Record<string, string> = {
    business_name: 'business_name',
    cnpj: 'cnpj',
    business_nickname: 'business_nickname',
    operator_status: 'operator_status',
    competence_date: 'competence_date',
    created_at: 'created_at',
    gross_amount: 'gross_amount',
    verification_status: 'verification_status',
  }

  const toggleSort = (columnKey: string) => {
    const backendField = sortableColumns[columnKey]
    if (!backendField) return
    const nextDirection = orderBy === backendField && orderDirection === 'asc' ? 'desc' : 'asc'
    setOrderBy(backendField)
    setOrderDirection(nextDirection)
    if (onSortChange) {
      onSortChange({ order_by: backendField, order_direction: nextDirection })
    }
  }

  React.useEffect(() => {
    const initialStatuses: Record<string, string> = {}
    data.forEach((row: any) => {
      initialStatuses[row.hashid] = row.operator_status || ''
    })
    setOperatorStatuses(initialStatuses)
  }, [data])

  const updateInvoiceStatus = async (hashid: string, newStatus: string) => {
    try {
      await UpdateOperatorStatus(Uid, access, client, newStatus, hashid)
      setOperatorStatuses((prev) => ({
        ...prev,
        [hashid]: newStatus,
      }))
      if (newStatus !== '') {
        setInvoiceAsAvailableToEdit(hashid, false)
        toast.success('Status atualizado com sucesso!')
        // Reset selection when status is updated
        resetSelection()
      }
    } catch (error) {
      console.error(error)
      toast.error('Erro ao atualizar status. Tente novamente.')
    }
  }

  const setInvoiceAsAvailableToEdit = (hashid: string, value = true) => {
    setCanEditByHashid((prev) => ({ ...prev, [hashid]: value }))
  }

  const onClickReabrir = async (hashid: string) => {
    handleMenuClose()
    await updateInvoiceStatus(hashid, '') // Reset status to allow editing
    setInvoiceAsAvailableToEdit(hashid)
    toast.success('Edição liberada para este item')
    // Reset selection when action is performed
    resetSelection()
  }

  // Selection handlers
  const resetSelection = React.useCallback(() => {
    setSelectedIds(new Set())
    if (onSelectionChange) {
      onSelectionChange([])
    }
  }, [onSelectionChange])

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelectedIds = new Set(data.map((row: any) => row.hashid).filter(Boolean))
      setSelectedIds(newSelectedIds)
      if (onSelectionChange) {
        onSelectionChange(Array.from(newSelectedIds))
      }
    } else {
      resetSelection()
    }
  }

  const handleSelectOne = (hashid: string) => {
    if (!hashid) {
      // console.warn('Attempted to select row without hashid')
      return
    }

    // console.log('Selecting/deselecting:', hashid)

    setSelectedIds((prevSelected) => {
      const newSelectedIds = new Set(prevSelected)
      const wasSelected = newSelectedIds.has(hashid)

      if (wasSelected) {
        newSelectedIds.delete(hashid)
        // console.log('Deselected:', hashid, 'New count:', newSelectedIds.size)
      } else {
        newSelectedIds.add(hashid)
        // console.log('Selected:', hashid, 'New count:', newSelectedIds.size)
      }

      // Notify parent immediately
      if (onSelectionChange) {
        onSelectionChange(Array.from(newSelectedIds))
      }

      return newSelectedIds
    })
  }

  const isSelected = (hashid: string) => selectedIds.has(hashid)
  const isAllSelected = data.length > 0 && selectedIds.size === data.length
  const isIndeterminate = selectedIds.size > 0 && selectedIds.size < data.length

  // Debug: Log current selection state
  // React.useEffect(() => {
  //   console.log('Current selectedIds Set:', selectedIds)
  //   console.log('Current selectedIds Array:', Array.from(selectedIds))
  //   console.log('Current selection size:', selectedIds.size)
  // }, [selectedIds])

  // Reset selection when pagination changes
  React.useEffect(() => {
    // console.log('Pagination changed, resetting selection')
    resetSelection()
  }, [page, rowsPerPage, resetSelection])

  // Reset selection when data actually changes (e.g., filters applied)
  // We use a ref to track the previous data length to avoid resetting on every render
  const prevDataLengthRef = React.useRef(data.length)
  React.useEffect(() => {
    // console.log('Checking data length - prev:', prevDataLengthRef.current, 'current:', data.length)
    if (prevDataLengthRef.current !== data.length) {
      // console.log('Data length changed from', prevDataLengthRef.current, 'to', data.length, '- resetting selection')
      resetSelection()
      prevDataLengthRef.current = data.length
    }
  }, [data.length, resetSelection])

  return (
    <>
      {loading ? (
        <Box alignContent={'center'} justifyContent={'center'} margin={'auto'}>
          <MoonLoader
            color={'#009d81'}
            size={25}
            aria-label="Loading Spinner"
            data-testid="loader"
            cssOverride={override}
          />
        </Box>
      ) : null}
      <ModalRefusalReason open={openReason} handleClose={() => setOpenReason(false)} reason={reasonText} />
      <ModalConfirm
        handleOpen={handleOpen}
        handleClose={handleClose}
        open={open}
        typeDelete="/shared_api/v1/invoices/"
        id={idnfs}
      />
      <CustomTable>
        <Title>Todas as Notas Fiscais</Title>
        <TableMain>
          <TableHead>
            <TableRow>
              <Cell align="center" padding="checkbox">
                <Checkbox
                  color="primary"
                  indeterminate={isIndeterminate}
                  checked={isAllSelected}
                  onChange={handleSelectAll}
                  inputProps={{
                    'aria-label': 'Selecionar todas as notas fiscais',
                  }}
                />
              </Cell>
              <Cell align="center">
                <Tooltip title="Nome empresarial da empresa emissora da nota fiscal" arrow>
                  <TableSortLabel
                    active={orderBy === 'business_name'}
                    direction={orderBy === 'business_name' ? orderDirection : 'asc'}
                    onClick={() => toggleSort('business_name')}
                  >
                    Razão social
                  </TableSortLabel>
                </Tooltip>
              </Cell>
              <Cell align="center">
                <Tooltip title="Cadastro Nacional de Pessoa Jurídica da empresa" arrow>
                  <TableSortLabel
                    active={orderBy === 'cnpj'}
                    direction={orderBy === 'cnpj' ? orderDirection : 'asc'}
                    onClick={() => toggleSort('cnpj')}
                  >
                    CNPJ
                  </TableSortLabel>
                </Tooltip>
              </Cell>
              <Cell align="center">
                <Tooltip title="Nome da unidade do hospital" arrow>
                  <TableSortLabel
                    active={orderBy === 'business_nickname'}
                    direction={orderBy === 'business_nickname' ? orderDirection : 'asc'}
                    onClick={() => toggleSort('business_nickname')}
                  >
                    Unidade
                  </TableSortLabel>
                </Tooltip>
              </Cell>
              <Cell align="center">
                <Box display="flex" alignItems="center" justifyContent="center" gap={0.5}>
                  <TableSortLabel
                    active={orderBy === 'operator_status'}
                    direction={orderBy === 'operator_status' ? orderDirection : 'asc'}
                    onClick={() => toggleSort('operator_status')}
                  >
                    Status do operador
                  </TableSortLabel>
                  <Tooltip
                    title={
                      <>
                        Status definido pelo operador para esta nota fiscal
                        <br />
                        <br />
                        Recusado pelo operador - utilize esse status quando a nota fiscal não for válida, ou quando
                        quiser recusá-la por algum motivo
                        <br />
                        <br />
                        Aprovado - nota fiscal válida e pronta para ser paga
                        <br />
                        <br />
                        Recebida fora da plataforma - nota fiscal enviada pelo prestador por outros meios (e-mail,
                        whatsapp, etc) ao invés de utilizar a plataforma Seiwa
                      </>
                    }
                    arrow
                  >
                    <InfoOutlinedIcon sx={{ fontSize: 16, color: colors['gray.400'], cursor: 'help' }} />
                  </Tooltip>
                </Box>
              </Cell>
              <Cell align="center">
                <Tooltip title="Data de referência dos serviços prestados" arrow>
                  <TableSortLabel
                    active={orderBy === 'competence_date'}
                    direction={orderBy === 'competence_date' ? orderDirection : 'desc'}
                    onClick={() => toggleSort('competence_date')}
                  >
                    Data de competência
                  </TableSortLabel>
                </Tooltip>
              </Cell>
              <Cell align="center">
                <Tooltip title="Data em que a nota fiscal foi recebida no sistema" arrow>
                  {/* <TableSortLabel
                    active={orderBy === 'created_at'}
                    direction={orderBy === 'created_at' ? orderDirection : 'asc'}
                    onClick={() => toggleSort('created_at')}
                  > */}
                  <span>Data do recebimento</span>
                  {/* </TableSortLabel> */}
                </Tooltip>
              </Cell>
              <Cell align="center">
                <Tooltip title="Valor bruto da nota fiscal" arrow>
                  <TableSortLabel
                    active={orderBy === 'gross_amount'}
                    direction={orderBy === 'gross_amount' ? orderDirection : 'asc'}
                    onClick={() => toggleSort('gross_amount')}
                  >
                    Valor
                  </TableSortLabel>
                </Tooltip>
              </Cell>
              <Cell align="center">
                <Box display="flex" alignItems="center" justifyContent="center" gap={0.5}>
                  {/* Oopsie, backend can't filter this one
                  <TableSortLabel
                    active={orderBy === 'verification_status'}
                    direction={orderBy === 'verification_status' ? orderDirection : 'asc'}
                    onClick={() => toggleSort('verification_status')}
                  > */}
                  Status do sistema
                  {/* </TableSortLabel> */}
                  <Tooltip
                    title={
                      <>
                        Status de verificação da nota fiscal, gerado automaticamente pela IA da Seiwa
                        <br />
                        <br />
                        Validada - nota fiscal válida
                        <br />
                        <br />
                        Recusada - nota fiscal foi enviada pelo prestador com dados divergentes. Prestador foi
                        informado.
                        <br />
                        <br />
                        Processando - nota fiscal está em processo de verificação
                        <br />
                        <br />
                        Não recebida - nota fiscal ainda não foi enviada pelo prestador
                      </>
                    }
                    arrow
                  >
                    <InfoOutlinedIcon sx={{ fontSize: 16, color: colors['gray.400'], cursor: 'help' }} />
                  </Tooltip>
                </Box>
              </Cell>
              <Cell align="center">
                <Tooltip title="Visualizar o PDF da nota fiscal" arrow>
                  <span>Visualizar</span>
                </Tooltip>
              </Cell>
              <Cell align="center">
                <Tooltip title="Ações disponíveis para esta nota fiscal" arrow>
                  <span>Ações</span>
                </Tooltip>
              </Cell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row: any, index: number) => {
              const isItemSelected = isSelected(row.hashid)
              const rowKey = row.hashid || index
              return (
                <TableRow
                  key={rowKey}
                  hover
                  selected={isItemSelected}
                  sx={{
                    backgroundColor: isItemSelected ? 'rgba(0, 157, 129, 0.08)' : 'inherit',
                    '&.Mui-selected': {
                      backgroundColor: 'rgba(0, 157, 129, 0.08)',
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: 'rgba(0, 157, 129, 0.12)',
                    },
                  }}
                >
                  <TableCell padding="checkbox" align="center">
                    <Checkbox
                      color="primary"
                      checked={isItemSelected}
                      disabled={!row.hashid}
                      onChange={() => handleSelectOne(row.hashid)}
                      inputProps={{
                        'aria-label': `Selecionar nota fiscal ${row.business_name || row.hashid}`,
                      }}
                    />
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    {row?.business_name || '--'}
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    {row?.cnpj ? cnpjMask(row?.cnpj) : '--'}
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    {row?.business_nickname || '--'}
                  </TableCell>
                  <TableCell align="center">
                    <FormControl sx={{ m: 1, minWidth: 150 }} size="small">
                      <Select
                        displayEmpty
                        disabled={Boolean(operatorStatuses[row.hashid]) && !canEditByHashid[row.hashid]}
                        value={operatorStatuses[row.hashid] ?? ''}
                        onChange={(e) => updateInvoiceStatus(row.hashid, e.target.value)}
                        renderValue={(selected) => operatorStatusLabels[selected] ?? 'Selecione'}
                      >
                        <MenuItem value="" onClick={() => updateInvoiceStatus(row.hashid, '')}>
                          Selecione
                        </MenuItem>
                        {Object.entries(operatorStatusLabels).map(([value, label]) => (
                          <MenuItem
                            key={value}
                            value={value}
                            disabled={
                              (value === 'approved' || value === 'refused_by_operator') && !row?.invoice?.pdf_file_url
                            }
                          >
                            {label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    {row?.competence_date ? moment(row?.competence_date).format('DD/MM/YYYY') : '--'}
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    {row?.invoice?.created_at ? moment(row?.invoice?.created_at).format('DD/MM/YYYY') : '--'}
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    {formatCurrency(row?.gross_amount)}
                  </TableCell>

                  <TableCell align="center">
                    {row?.invoice?.verification_status === 'validated' ? (
                      <Box
                        minWidth={110}
                        bgcolor={colors['green.default']}
                        color="white"
                        borderRadius={100}
                        textAlign="center"
                        py="2px"
                        display={'inline-block'}
                      >
                        {'Validada'}
                      </Box>
                    ) : row?.invoice?.verification_status === 'pending' ? (
                      <Box
                        minWidth={110}
                        bgcolor={colors.warn}
                        color="white"
                        borderRadius={100}
                        textAlign="center"
                        py="2px"
                        display={'inline-block'}
                      >
                        {'Processando'}
                      </Box>
                    ) : row?.invoice?.verification_status === 'refused' ? (
                      <Box
                        minWidth={110}
                        bgcolor={colors.error}
                        color="white"
                        borderRadius={100}
                        textAlign="center"
                        py="2px"
                        display={'inline-block'}
                      >
                        {'Recusada'}
                      </Box>
                    ) : (
                      <Box
                        minWidth={110}
                        bgcolor={colors['gray.400']}
                        color="white"
                        borderRadius={100}
                        textAlign="center"
                        py="2px"
                        display={'inline-block'}
                      >
                        {'Não recebida'}
                      </Box>
                    )}
                  </TableCell>

                  <TableCell align="center">
                    <IconButton
                      disabled={row?.invoice?.pdf_file_url === null}
                      aria-label="delete"
                      onClick={() => {
                        window.open(row?.invoice?.pdf_file_url, '_blank', '')
                      }}
                    >
                      <VisibilityIcon
                        fontSize="small"
                        sx={{
                          color: row?.invoice?.pdf_file_url === null ? colors['gray.200'] : colors['green.default'],
                        }}
                      />
                    </IconButton>
                  </TableCell>
                  <TableCell align="center">
                    <IconButton onClick={(e) => handleMenuOpen(e, row)} aria-label="actions">
                      <MoreVertIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </TableMain>
        <Menu
          anchorEl={menuAnchorEl}
          open={Boolean(menuAnchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MenuItem
            disabled={!operatorStatuses[menuRow?.hashid] || canEditByHashid[menuRow?.hashid]}
            onClick={() => onClickReabrir(menuRow?.hashid)}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <EditNoteIcon fontSize="small" sx={{ color: colors.blue }} />
              Reabrir
            </Box>
          </MenuItem>
          <MenuItem
            disabled={!menuRow?.invoice?.refusal_error}
            onClick={() => {
              const reason = menuRow?.invoice?.refusal_error || ''

              // Maybe it would be better to move this mapping to a utility if being used elsewhere
              const REASON_MAP: Record<string, string> = {
                'InvalidInvoiceError::DataValidationFailed': 'Falha na validação dos dados',
                'InvalidInvoiceError::ProcessingError': 'Erro durante o processamento',
                'InvalidInvoiceError::CnpjMismatch': 'CNPJ divergente entre sistema e NF',
                'InvalidInvoiceError::AmountMismatch': 'Valor divergente entre sistema e NF',
                'InvalidInvoiceError::DateMismatch': 'Data/competência divergente entre sistema e NF',
                'InvalidInvoiceError::TaxMismatch': 'Tributação/impostos divergentes',
                'InvalidInvoiceError::DownloadFailed': 'Falha ao baixar o PDF da nota fiscal',
              }

              const translatedReason = REASON_MAP[reason] || 'Processo de validação falhou'
              setReasonText(translatedReason)
              setOpenReason(true)
              handleMenuClose()
            }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <DescriptionIcon fontSize="small" sx={{ color: colors.blue }} />
              Ver motivo do erro
            </Box>
          </MenuItem>
          <MenuItem
            disabled={!menuRow?.invoice?.hashid}
            onClick={() => {
              setIdnfs(menuRow?.invoice?.hashid)
              handleOpen()
              handleMenuClose()
            }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <DeleteIcon fontSize="small" sx={{ color: colors.error }} />
              Excluir
            </Box>
          </MenuItem>
        </Menu>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 100]}
          labelRowsPerPage="Itens por página"
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(e, newPage) => onPageChange(newPage)}
          onRowsPerPageChange={(e) => {
            const newRows = parseInt(e.target.value, 10)
            onRowsPerPageChange(newRows)
          }}
        />
      </CustomTable>
    </>
  )
}
